import { lazy, ReactNode, Suspense } from 'react';

import { Fallback } from 'router/Fallback';

const TrialRequestPage = lazy(() => import('pages/opl/trial/TrialRequest'));
const TrialSuccessPage = lazy(() => import('pages/opl/trial/TrialSuccess'));
const TrialErrorPage = lazy(() => import('pages/opl/trial/TrialError'));

const wrap = (element: ReactNode) => <Suspense fallback={<Fallback />}>{element}</Suspense>;

export const OplRoutes = [
  {
    path: 'opl',
    children: [
      {
        path: 'trial',
        children: [
          { index: true, element: wrap(<TrialRequestPage />) },
          { path: 'success', element: wrap(<TrialSuccessPage />) },
          { path: 'error', element: wrap(<TrialErrorPage />) },
        ],
      },
    ],
  },
];
